import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import AddingIndividually from "./AddingIndividually";
import { useAppSelector } from "app/hooks";
import { selectClassInfo } from "features/Students";
import AddingList from "./AddingList";
import UploadFile from "./UploadFile";

const customStyles = {
  root: {
    direction: "rtl",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "600px",
    padding: "20px",
    color: "rgb(105 123 140)",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "17px",
    overflowY: "auto",
    overflowX: "hidden",
    alignItems: "center",
    justifyContent: "flex-start",
    "& > :not(:last-child)": {
      paddingBottom: "10px",
    },
  },
};
interface IContentProps {
  onSubmit(): void;
}

enum AddingMethodTypes {
  "Individually" = "Individually",
  "List" = "List",
  "UploadFile" = "UploadFile",
}
function Content({ onSubmit }: IContentProps) {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(AddingMethodTypes.Individually);
  const classInfo = useAppSelector((state) => selectClassInfo(state));
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value as AddingMethodTypes);
  };
  return (
    <Typography component="div" sx={customStyles.root}>
      <Typography sx={{ color: "rgb(105 123 140)", fontSize: "16px" }}>
        {`${t("Class")}: ${classInfo?.name}`}
      </Typography>
      <Typography
        sx={{ color: "rgb(60 180 229)", fontSize: "16px", padding: "20px 0" }}
      >
        {t("Select method to create students")}
      </Typography>
      <FormControl
        sx={{
          width: "100%",
          padding: "20px 0",
          borderBottom: "1px solid rgb(217 217 217)",
          direction: i18n.dir(),
        }}
        tabIndex={-1}
      >
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={value}
          onChange={handleChange}
          tabIndex={-1}
        >
          <FormControlLabel
            value={AddingMethodTypes.Individually}
            control={<Radio />}
            label={t("Adding Individually")}
            tabIndex={-1}
          />
          <FormControlLabel
            value={AddingMethodTypes.List}
            control={<Radio />}
            label={t("Adding List")}
            tabIndex={-1}
          />
          <FormControlLabel
            value={AddingMethodTypes.UploadFile}
            control={<Radio />}
            label={t("Upload File")}
            tabIndex={-1}
          />
        </RadioGroup>
      </FormControl>
      {selectMethod()}
    </Typography>
  );

  function selectMethod() {
    switch (value) {
      case AddingMethodTypes.Individually:
        return (
          <AddingIndividually onSubmit={onSubmit} classDetails={classInfo} />
        );
      case AddingMethodTypes.List:
        return <AddingList onSubmit={onSubmit} classDetails={classInfo} />;
      case AddingMethodTypes.UploadFile:
      default:
        return <UploadFile onSubmit={onSubmit} classDetails={classInfo} />;
    }
  }
}

export default Content;
